import { WeatherScene } from '@/scene/WeatherScene';

export default function App() {
  return <WeatherScene />;
}
